import { HomeIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface BackToHomeButtonProps {
  onClick: VoidFunction
}

export const BackToHomeButton = ({ onClick }: BackToHomeButtonProps) => {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className={cn('flex items-center gap-x-1.5', 'text-slate-500')}
      onClick={onClick}
    >
      <HomeIcon size={16}></HomeIcon>
      <span className={cn('text-xs font-medium')}>Back to Home</span>
    </Button>
  )
}
